import cn from 'classnames';
import styles from './Divider.module.scss';

type DividerProps = {
  className?: string;
};

export function Divider({ className }: DividerProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  return <div className={wrapperClassName} />;
}
